package ui.app.assign.detail.definition

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import api.ResourceOrientation
import compose.assets.Svg
import compose.assets.svg.Format_text
import ssoft.frontend.generated.resources.*
import tools.EFieldTextString
import tools.rememberString
import ui.app.assign.detail.AppDetailScope
import ui.widget.Space
import kotlin.math.roundToInt

@Composable
fun AppDetailScope.AppDefOfMaze(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfMaze
) {
    if (display.isMobile) {
        Column {
            DefaultFields(
                nnvl = wrapper,
                modifier = Modifier.fillMaxWidth(),
                secondaryContent = {
                    Title(
                        nnvl = wrapper,
                        field = nnvl.title,
                        modifier = Modifier.fillMaxWidth()
                    )
                    Space(16.dp)
                    ImagePickers(nnvl, wrapper)
                    Space(16.dp)
                    TimersSettings(nnvl, wrapper)
                    Space(16.dp)
                    Scale(wrapper, nnvl)
                    Space(16.dp)
                }
            )
        }
    } else {
        Row(horizontalArrangement = Arrangement.spacedBy(16.dp)) {
            Column(Modifier.weight(1F)) {
                DefaultFields(
                    nnvl = wrapper,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    TimersSettings(nnvl, wrapper)
                    Space(16.dp)
                }
            }
            Column(Modifier.weight(1F)) {
                Title(
                    nnvl = wrapper,
                    field = nnvl.title,
                    modifier = Modifier.fillMaxWidth()
                )
                Space(16.dp)
                ImagePickers(nnvl, wrapper)
                Space(16.dp)
                Scale(wrapper, nnvl)
                Space(16.dp)
            }
        }
    }
    Space(64.dp)
}


@Composable
private fun AppDetailScope.ImagePickers(
    nnvl: AppDetailScope.WrapperDefinition.OfMaze,
    wrapper: AppDetailScope.Wrapper
) {
    ImagePicker(
        field = nnvl.splashLand,
        label = Res.string.layer_bottom_detail__maze_splash_land,
        wrapper = wrapper,
        restrictionOrientation = ResourceOrientation.HORIZONTAL.mask,
        modifier = Modifier.fillMaxWidth()
            .aspectRatio(16F / 9F)
    )
    Space(16.dp)
    ImagePicker(
        field = nnvl.splashPort,
        label = Res.string.layer_bottom_detail__maze_splash_port,
        wrapper = wrapper,
        restrictionOrientation = ResourceOrientation.VERTICAL.mask,
        modifier = Modifier.fillMaxWidth()
            .aspectRatio(9F / 16F)
    )
}

@Composable
private fun AppDetailScope.Title(
    nnvl: AppDetailScope.Wrapper,
    field: EFieldTextString,
    modifier: Modifier
) {
    Card(
        modifier = modifier
    ) {
        Column(
            Modifier.padding(horizontal = 16.dp)
                .padding(bottom = 16.dp, top = 8.dp)
        ) {
            TextField(
                readOnly = !nnvl.canEdit,
                value = field.text,
                onValueChange = { field.set(it) },
                modifier = Modifier.fillMaxWidth(),
                leadingIcon = { Icon(Svg.Format_text, "") },
                label = { Text(Res.string.layer_bottom_detail__maze_title.rememberString()) })
        }
    }
}


@Composable
private fun AppDetailScope.TimersSettings(
    nnvl: AppDetailScope.WrapperDefinition.OfMaze,
    wrapper: AppDetailScope.Wrapper
) {
    TimersSettings(
        timerSplash = nnvl.timerSplash,
        timerGame = nnvl.timerGame,
        timerResult = nnvl.timerResult,
        stepsGame = 3
    )
}

@Suppress("UnusedReceiverParameter")
@Composable
private fun AppDetailScope.Scale(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfMaze,
    modifier: Modifier = Modifier.fillMaxWidth()
) {
    Card(modifier = modifier) {
        Column(Modifier.padding(16.dp)) {
            Text(Res.string.layer_bottom_detail__maze_scale_label.rememberString())
            Space(8.dp)
            Row(Modifier.padding(horizontal = 8.dp)) {
                Text(
                    text = "${(nnvl.scale.state * 100F).roundToInt()}%",
                    modifier = Modifier.align(Alignment.CenterVertically),
                    fontWeight = FontWeight.Bold
                )
                Space(8.dp)
                Slider(
                    enabled = wrapper.canEdit,
                    modifier = Modifier.align(Alignment.CenterVertically),
                    value = nnvl.scale.state,
                    valueRange = 0.5F..1F,
                    steps = 4,
                    onValueChange = {
                        nnvl.scale.set(it)
                    }
                )
            }
        }
    }
}